var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "formRef",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "140px" },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "规则名称", prop: "ruleName" } },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入规则名称" },
            model: {
              value: _vm.form.ruleName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "ruleName", $$v)
              },
              expression: "form.ruleName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "默认额度", prop: "defaultLimit" } },
        [
          _c("el-input-number", {
            attrs: { min: 0, step: 1, placeholder: "请输入默认额度" },
            model: {
              value: _vm.form.defaultLimit,
              callback: function ($$v) {
                _vm.$set(_vm.form, "defaultLimit", $$v)
              },
              expression: "form.defaultLimit",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "生效逻辑", prop: "effectiveLogic" } },
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "请选择生效逻辑" },
              model: {
                value: _vm.form.effectiveLogic,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "effectiveLogic", $$v)
                },
                expression: "form.effectiveLogic",
              },
            },
            [
              _c("el-option", { attrs: { label: "每月", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "每季度", value: 2 } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "优惠券", prop: "" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "300px", "margin-right": "10px" },
              attrs: {
                placeholder: "请输入优惠券，支持模糊查询",
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                "remote-method": _vm.fetchCoupons1,
                loading: _vm.couponLoading,
                disabled: !!_vm.form.id,
              },
              model: {
                value: _vm.form.couponId,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "couponId", $$v)
                },
                expression: "form.couponId",
              },
            },
            _vm._l(_vm.couponOptions1, function (coupon, index) {
              return coupon
                ? _c("el-option", {
                    key: (coupon && coupon.thirdCouponId) || index,
                    attrs: {
                      label: coupon && coupon.typeName,
                      value: coupon && coupon.thirdCouponId,
                    },
                  })
                : _vm._e()
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "券名称", prop: "couponName" } },
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "请选择券名称" },
              model: {
                value: _vm.form.couponName,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "couponName", $$v)
                },
                expression: "form.couponName",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "买一赠一券", value: "买一赠一券" },
              }),
              _vm._v(" "),
              _c("el-option", {
                attrs: { label: "饮品免费券", value: "饮品免费券" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动状态" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "status", $$v)
                },
                expression: "form.status",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("未启用")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "门店", prop: "" } },
        _vm._l(_vm.shoplist, function (city, index) {
          return _c(
            "div",
            { key: index, staticStyle: { "margin-top": "8px" } },
            [
              _c(
                "el-checkbox",
                {
                  staticStyle: { "font-weight": "600" },
                  attrs: {
                    checked: _vm.isCityAllSelected(city),
                    indeterminate: _vm.isCityIndeterminate(city),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.toggleCity(city, $event)
                    },
                  },
                },
                [_vm._v(_vm._s(city.regionName))]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox-group",
                {
                  staticStyle: { "margin-left": "20px" },
                  model: {
                    value: _vm.checkedCities,
                    callback: function ($$v) {
                      _vm.checkedCities = $$v
                    },
                    expression: "checkedCities",
                  },
                },
                _vm._l(city.dealerList, function (shop) {
                  return _c(
                    "el-checkbox",
                    {
                      key: shop.dealerId,
                      staticStyle: {
                        display: "inline",
                        "margin-right": "60px",
                      },
                      attrs: { label: shop.dealerId },
                      on: {
                        change: function ($event) {
                          return _vm.changeShop(shop, $event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(shop.dealerName) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }